module.exports = __webpack_public_path__ + "static/media/fal_fal_oh_wor.25717292.png";